import { EmailBuilderConfigurationKey } from 'src/components/email-builder/types';

export const emptyFieldTextErrorMessage = 'Field cannot be empty';

export const EMAIL_RESPONSE = 'Response';
export const JOURNEY_MAP = 'Journey';
export const INTERACTIVE = 'Interactive';

export const TOOLS_TAB_COMPONENT_TYPES: EmailBuilderConfigurationKey[] = [
  'text_message',
  'button',
  'image',
  'html',
];

export const HELPDESKS_USING_RAW_TEMPLATE = ['intercom'];
